import { resetAllValues, openMultistepSection } from './multistepFunctions';

/**
 * Select Date 
 * 
 * @param {*} id 
 */

export const selectEventDate = (id) => {
  toggleEventClass("calendar-btn", id, "event-clicked");
  let allDateSlotBtns = document.querySelectorAll(".time-slots-group");
  allDateSlotBtns.forEach(function (dateSlotBtn) {
    if (dateSlotBtn.getAttribute("id") != id.substr(4)) {
      dateSlotBtn.style.display = "none";
    } else {
      dateSlotBtn.style.display = "flex";
    }
  });
  resetAllValues(document.getElementById("event-calendar-ticket-price-section"));
  resetAllValues(document.getElementById("final-checkout-section"));
  openMultistepSection("event-calendar-slot-section");
}
 
/**
 * Multistep Checkout - Time Section
 *
 * @param {*} id
 * @param {*} people
 */

export const checkoutDateTimeSelect = (id, people) => {
  toggleEventClass("time-slot-btn", id, "slot-clicked");
  let sectionID = "event-calendar-ticket-price-section";
  resetAllValues(document.getElementById(sectionID));
  openMultistepSection(sectionID);
  let section = document.querySelectorAll("#" + sectionID + " .quantity");
  section.forEach(function (row) {
    row.querySelector(".qty-input").max = people;
  });
  document.getElementById("final-checkout-section").dataset.selectedSlot = id.substring(5);
};

/**
 * Assign Class to Buttons
 *
 * @param {*} classSelector
 * @param {*} idSelector
 * @param {*} classString
 */

const toggleEventClass = (classSelector, idSelector, classString) => {
    let selector = document.querySelectorAll("." + classSelector);
    selector.forEach(function (element) {
      if (element.getAttribute("id") != idSelector) {
        element.classList.remove(classString);
      } else {
        element.classList.add(classString);
      }
    });
  };